import { formatAbsoluteDateTime } from '../../lib/formatters';
import { useDashboardNotes } from '../../services/api/hooks/useDashboardNotes';
import { useFilterStore } from '../filters/filterStore';

export const NoteClientCard = () => {
  const { entityIds, contractIds, siteIds, dateRange } = useFilterStore();
  const query = useDashboardNotes({ entityIds, contractIds, siteIds, dateRange });

  const notes = query.data?.notes ?? [];

  // Masqué si aucune note ou si erreur silencieuse
  if (query.error) return null;
  if (!query.isLoading && notes.length === 0) return null;

  return (
    <article className="rounded-md border border-zinc-200 bg-white p-5 flex flex-col gap-3">
      <header className="flex items-baseline justify-between">
        <div>
          <h2 className="text-sm font-medium text-zinc-900">Notes clients</h2>
          <p className="text-xs text-zinc-500 mt-0.5">
            Remontées saisies au moment des courses sur le périmètre filtré
          </p>
        </div>
        {!query.isLoading ? (
          <span className="text-xs font-mono tabular-nums text-zinc-500">
            {notes.length} note{notes.length > 1 ? 's' : ''}
          </span>
        ) : null}
      </header>

      {query.isLoading ? (
        <ul className="flex flex-col gap-2">
          {[1, 2, 3].map(i => (
            <li key={i} className="h-12 rounded-sm skeleton-pulse" />
          ))}
        </ul>
      ) : (
        <ul className={notes.length > 5 ? 'flex flex-col max-h-72 overflow-y-auto pr-1' : 'flex flex-col'}>
          {notes.map((note, idx) => (
            <li
              key={note.id}
              className={['py-2.5', idx < notes.length - 1 ? 'border-b border-zinc-100' : ''].join(' ')}
            >
              <p className="text-sm text-zinc-800 leading-relaxed">{note.content}</p>
              <div className="flex items-center gap-2 mt-1.5 text-xs">
                <span className="font-mono tabular-nums text-zinc-500">{note.externalRef}</span>
                <span className="text-zinc-300">·</span>
                <span className="font-mono tabular-nums text-zinc-500">{formatAbsoluteDateTime(note.createdAt)}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};
